export const reverseString = (string: string) => {
    const splitString = string.split('');
    return splitString.reverse().join('');
};

export const objectKeys = <Obj>(obj: Obj): (keyof Obj)[] => {
    return Object.keys(obj) as (keyof Obj)[]
}
